export class FiltroConsumidorReceitaFederal {

    cpf: string;
    dataNascimento: string;
    nomeMae: string;

    constructor(cpf: string, dataNascimento: string, nomeMae: string) {
        this.cpf = cpf;
        this.dataNascimento = dataNascimento;
        this.nomeMae = nomeMae;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-consumidor-receita-federal.ts